import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import * as S from './styles';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdRefresh, MdDelete } from 'react-icons/md';

// Componentes
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// Serviços
import BuscaRedes from '../../services/Marketdo/BuscaRedes';
import Buscarredecnpj from '../../services/rede_cnpj/Buscarredecnpj';
import RedeCnpjService from '../../services/rede_cnpj/RedeCnpjService';
import sendUpload from '../../services/Logo_Moldura/Upload';
import deleteMoldura from '../../services/Logo_Moldura/deleteMoldura';
import ImageViewer from '../../services/Logo_Moldura/ImageViewer';
import MoldurasGallery from '../../components/MoldurasGallery';
import LogosGallery from '../../components/LogosGallery';

function CNPJsRede() {
    const [redes, setRedes] = useState([]);
    const [redeSelecionada, setRedeSelecionada] = useState('');
    const [idRede, setIdRede] = useState('');
    const [resultados, setResultados] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [timestamp, setTimestamp] = useState(Date.now());
    const [refreshGallery, setRefreshGallery] = useState(0);
    const [formData, setFormData] = useState({
        id: '',
        id_rede: '',
        nome_fantasia: '',
        razao_social: '',
        cpf_cnpj: '',
        endereco: '',
        telefone: '',
        logo: '',
    });

    const navigate = useNavigate();

    useEffect(() => {
        const fetchRedes = async () => {
            try {
                const buscaRedes = new BuscaRedes();
                await buscaRedes.loadRede();
                setRedes(buscaRedes.getResultadoRede());
            } catch (error) {
                console.error('Erro ao buscar redes:', error);
            }
        };

        fetchRedes();
    }, []);

    const handleSelectRede = (e) => {
        const selectedId = e.target.value;
        setRedeSelecionada(selectedId);

        const rede = redes.find((rede) => rede._id.$oid === selectedId);
        if (rede) {
            setIdRede(rede._id.$oid);
            setTimestamp(Date.now());
            setRefreshGallery(prev => prev + 1);
        } else {
            setIdRede('');
        }
    };

    const handleBuscarRedeCNPJ = async () => {
        if (!idRede) {
            alert('Por favor, selecione uma rede válida antes de buscar.');
            return;
        }

        try {
            const resultado = await Buscarredecnpj(idRede);
            if (resultado && resultado.cadastros) {
                setResultados(resultado.cadastros);
                setIsModalOpen(true);
            } else {
                alert('Nenhum dado encontrado para a rede selecionada.');
            }
        } catch (error) {
            console.error('Erro ao buscar Rede CNPJ:', error);
            alert('Erro ao buscar Rede CNPJ.');
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleSelectCadastro = (cadastro) => {
        setFormData({
            id: cadastro._id.$oid,
            id_rede: cadastro.id_rede,
            nome_fantasia: cadastro.nome_fantasia,
            razao_social: cadastro.razao_social,
            cpf_cnpj: cadastro.cpf_cnpj,
            endereco: cadastro.endereco,
            telefone: cadastro.telefone,
            logo: cadastro.logo || '',
        });
        setIdRede(cadastro.id_rede);
        closeModal();
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (!file || !idRede) {
            alert("Arquivo ou ID da rede não definido.");
            return;
        }

        const img = new Image();
        img.onload = function () {
            if (img.width < 50 || img.height < 50) {
                alert("A imagem precisa ter pelo menos 50x50 pixels.");
                e.target.value = '';
                return;
            }
            if (file instanceof File) {
                setSelectedFile(file);
            } else {
                alert("Erro: o arquivo selecionado não é válido.");
            }
        };
        img.onerror = function () {
            alert("Erro ao carregar a imagem.");
            e.target.value = '';
        };
        img.src = URL.createObjectURL(file);
    };

    const handleUploadLogo = async () => {
        if (!selectedFile || !(selectedFile instanceof File) || !idRede) {
            alert("Selecione uma imagem válida e uma rede.");
            return;
        }

        try {
            const timestamp = Date.now();
            const nomeArquivo = `logo_${idRede}_${timestamp}.png`;
            const formDataUpload = new FormData();

            formDataUpload.append('file', selectedFile);
            formDataUpload.append('id_rede', idRede);
            formDataUpload.append('tipo', 'logo');
            formDataUpload.append('descricao', formData.nome_fantasia || 'Logo');
            formDataUpload.append('ativo', 'true');
            formDataUpload.append('nome_arquivo', nomeArquivo);

            const response = await sendUpload(idRede, formDataUpload);
            const nomeArquivoServidor = response.filename || nomeArquivo;
            
            setFormData(prev => ({ ...prev, logo: nomeArquivoServidor }));
            setTimestamp(Date.now());
            setRefreshGallery(prev => prev + 1);
            setSelectedFile(null);
            
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
            
            alert('Logo enviado com sucesso!');
        } catch (error) {
            console.error('Erro detalhado:', error);
            alert('Erro ao fazer upload do logo: ' + (error.message || 'Erro desconhecido'));
        }
    };

    const handleDeleteLogo = async (nomeArquivo) => {
        if (window.confirm('Tem certeza que deseja excluir este logo?')) {
            try {
                await deleteMoldura(idRede, nomeArquivo);
                setFormData(prev => ({ ...prev, logo: '' }));
                setRefreshGallery(prev => prev + 1);
                alert('Logo excluído com sucesso!');
            } catch (error) {
                console.error('Erro ao excluir logo:', error);
                alert(error.message || 'Erro ao excluir logo');
            }
        }
    };

    const handleRefreshGallery = () => {
        setRefreshGallery(prev => prev + 1);
        setTimestamp(Date.now());
    };

    const handleSelectMoldura = (moldura) => {
        setFormData(prev => ({ ...prev, logo: moldura.nome }));
        setTimestamp(Date.now());
    };

    const handleSelectLogo = (logo) => {
        setFormData(prev => ({ ...prev, logo: logo.nome }));
        setTimestamp(Date.now());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!idRede) {
            alert('O campo id_rede é obrigatório. Certifique-se de selecionar uma rede.');
            return;
        }

        const payload = {
            id_rede: idRede,
            nome_fantasia: formData.nome_fantasia,
            razao_social: formData.razao_social,
            cpf_cnpj: formData.cpf_cnpj,
            endereco: formData.endereco,
            telefone: formData.telefone,
            logo: formData.logo,
        };

        try {
            if (formData.id) {
                await RedeCnpjService.updateRedeCnpj(formData.id, payload);
                alert('Cadastro atualizado com sucesso!');
            } else {
                const response = await RedeCnpjService.saveRedeCnpj(payload);
                alert('Cadastro salvo com sucesso!');
                setIdRede(response.id_rede);
            }

            setFormData({
                id: '',
                id_rede: '',
                nome_fantasia: '',
                razao_social: '',
                cpf_cnpj: '',
                endereco: '',
                telefone: '',
                logo: '',
            });
            setIdRede('');
            setRedeSelecionada('');
        } catch (error) {
            console.error('Erro ao salvar ou atualizar o cadastro:', error);
            alert('Erro ao salvar ou atualizar o cadastro.');
        }
    };

    return (
        <>
            <Header />
            <S.BackButton onClick={() => navigate('/Marketdo')}>
                <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
                Voltar
            </S.BackButton>
            <S.ContainerUnico>
                <S.Title>Cadastro de CNPJs Rede</S.Title>
                <S.Form>
                    <S.Coluna>
                        <S.InputGroup>
                            <S.Label>Selecione uma Rede:</S.Label>
                            <S.Select value={redeSelecionada} onChange={handleSelectRede}>
                                <option value="">Selecione...</option>
                                {redes.map((rede) => (
                                    <option key={rede._id.$oid} value={rede._id.$oid}>
                                        {rede.nome_fantasia}
                                    </option>
                                ))}
                            </S.Select>
                        </S.InputGroup>

                        {idRede && (
                            <>
                                <S.InputGroup>
                                    <S.Label>Nome Fantasia:</S.Label>
                                    <S.Input
                                        type="text"
                                        value={formData.nome_fantasia}
                                        onChange={(e) => setFormData({ ...formData, nome_fantasia: e.target.value })}
                                    />
                                </S.InputGroup>

                                <S.InputGroup>
                                    <S.Label>Razão Social:</S.Label>
                                    <S.Input
                                        type="text"
                                        value={formData.razao_social}
                                        onChange={(e) => setFormData({ ...formData, razao_social: e.target.value })}
                                    />
                                </S.InputGroup>

                                <S.InputGroup>
                                    <S.Label>CPF/CNPJ:</S.Label>
                                    <S.Input
                                        type="text"
                                        value={formData.cpf_cnpj}
                                        onChange={(e) => setFormData({ ...formData, cpf_cnpj: e.target.value })}
                                    />
                                </S.InputGroup>

                                <S.InputGroup>
                                    <S.Label>Endereço:</S.Label>
                                    <S.Input
                                        type="text"
                                        value={formData.endereco}
                                        onChange={(e) => setFormData({ ...formData, endereco: e.target.value })}
                                    />
                                </S.InputGroup>

                                <S.InputGroup>
                                    <S.Label>Telefone:</S.Label>
                                    <S.Input
                                        type="text"
                                        value={formData.telefone}
                                        onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                                    />
                                </S.InputGroup>

                                <S.InputGroup>
                                    <S.Label>Logo:</S.Label>
                                    <S.Input type="file" accept="image/*" onChange={handleLogoChange} />
                                    {selectedFile && (
                                        <S.Button type="button" onClick={handleUploadLogo}>
                                            Enviar Logo
                                        </S.Button>
                                    )}
                                </S.InputGroup>

                                <S.ButtonGroup>
                                    <S.Button type="button" onClick={handleSubmit}>Salvar</S.Button>
                                    <S.Button type="button" onClick={() => setFormData({})}>Limpar</S.Button>
                                    <S.Button type="button" onClick={handleBuscarRedeCNPJ}>Buscar Rede CNPJ</S.Button>
                                </S.ButtonGroup>
                            </>
                        )}
                    </S.Coluna>

                    <S.Coluna>
                        {idRede ? (
                            <>
                                <div>
                                    <S.PreviewTitle>
                                        <span>Visualização do Logo:</span>
                                        <S.RefreshButton onClick={handleRefreshGallery}>
                                            <MdRefresh />
                                        </S.RefreshButton>
                                    </S.PreviewTitle>
                                    <S.PreviewContainer>
                                        {formData.logo ? (
                                            <>
                                                <ImageViewer 
                                                    nomeArquivo={formData.logo} 
                                                    idRede={idRede} 
                                                    timestamp={timestamp}
                                                    key={`image-${timestamp}`}
                                                />
                                                <S.DeleteButton 
                                                    onClick={() => handleDeleteLogo(formData.logo)}
                                                    title="Excluir logo"
                                                >
                                                    <MdDelete />
                                                </S.DeleteButton>
                                            </>
                                        ) : (
                                            <div>Nenhum logo selecionado</div>
                                        )}
                                    </S.PreviewContainer>
                                </div>

                                <div>
                                    <h3>Logos Disponíveis</h3>
                                    <LogosGallery 
                                        idRede={idRede} 
                                        onSelectLogo={handleSelectLogo}
                                        onDeleteLogo={handleDeleteLogo}
                                        key={`gallery-${refreshGallery}`}
                                    />
                                </div>
                            </>
                        ) : (
                            <p>Selecione uma rede para visualizar o logo.</p>
                        )}
                    </S.Coluna>
                </S.Form>
            </S.ContainerUnico>

            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                ariaHideApp={false}
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        maxHeight: '70vh',
                        overflowY: 'auto',
                    },
                }}
            >
                <h2>Resultados da Busca</h2>
                <button onClick={closeModal}>Fechar</button>
                <S.TableContainer>
                    <S.Table>
                        <thead>
                            <tr>
                                <th>Nome Fantasia</th>
                                <th>Razão Social</th>
                                <th>CPF/CNPJ</th>
                                <th>Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            {resultados.map((cadastro) => (
                                <tr key={cadastro._id.$oid}>
                                    <td>{cadastro.nome_fantasia}</td>
                                    <td>{cadastro.razao_social}</td>
                                    <td>{cadastro.cpf_cnpj}</td>
                                    <td>
                                        <button onClick={() => handleSelectCadastro(cadastro)}>
                                            Selecionar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </S.Table>
                </S.TableContainer>
            </Modal>
            <Footer />
        </>
    );
}

export default CNPJsRede;